// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"dfcde764","453":"9a0dbae2","477":"1f1e1da9"}[chunkId] + ".chunk.js";
};